import { simulatePlayoffOdds } from "@averagejoesff/shared";
import type { LeagueHistory, PlayoffOdds } from "@averagejoesff/shared";

/**
 * The forecast takes a moment (10,000 simulated seasons), so it's kept per
 * history: Home and Milestones share one run, and leaving a page and coming
 * back within the history's reuse window (see `leagueHistory.ts`) shows it
 * again without recomputing.
 */
const oddsCache = new WeakMap<LeagueHistory, PlayoffOdds | null>();

/** Null once the season is over, in the playoffs, or when the schedule hasn't been recorded. */
export function playoffOddsFor(history: LeagueHistory): PlayoffOdds | null {
  if (!oddsCache.has(history)) oddsCache.set(history, simulatePlayoffOdds(history));
  return oddsCache.get(history) ?? null;
}
